import {
  ListPickProps,
  ListPickWithFetcherProps,
} from '../../../components/ListPicker/useListPick.types';
import { PaginatedResponse } from '../../../types/request.types';

interface CreateParamsToUseListPickWhenOfflineParams {
  isOnline: boolean;
  onlineProps: ListPickWithFetcherProps;
  offlineFetcher: (params: { limit: number; skip: number }) => Promise<PaginatedResponse<unknown>>;
}

export const createParamsToUseListPickWhenOffline = ({
  isOnline,
  offlineFetcher,
  onlineProps,
}: CreateParamsToUseListPickWhenOfflineParams): ListPickProps => {
  if (isOnline) {
    return onlineProps;
  }

  return {
    customFetcher: async (params) => {
      const data = await offlineFetcher(params);
      return { ok: true, data, originalError: null, problem: null };
    },
  };
};
